import React, { useState, useEffect } from "react";
import { Dropdown } from "semantic-ui-react";
import CreateAxios from "../axiosComponent/create";
import ModalCreateConsignor from "../createShipmentComponent/modalCreateConsigner";

const ConsignorWithCreate = ({
  field: { name },
  form: { setFieldValue },
  fillAddressState,
  ...props
}) => {
  const [consignor, setConsignor] = useState([]);
  const [isloading, setisloading] = useState(false);
  let [addedConsignor, setAddedConsignor] = useState(false);
  let [Txt, setTxt] = useState("");

  useEffect(() => {
  }, [addedConsignor]);

  let handleSearch = (e, data) => {
    setisloading(true);
    let searchTerm = data.searchQuery;
    setTxt(data.searchQuery);
    setFieldValue(name, data.value);
    CreateAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/consignorMaster`,
      payload: { searchTerm: searchTerm },
    })
      .then((result) => {
        setConsignor(result.data.resultSet);
        setisloading(false);
      })
      .catch((error) => console.log(error));
  };

  let consignorNames = [];
  if (consignor.length > 0) {
    const filterdBillers = consignor.filter(obj => { return obj.consignorName.toLowerCase().startsWith(Txt) })
    filterdBillers.map((object, index) => {
      let temp = {};
      temp.key = object.consignorId;
      temp.text = `${object.consignorName} (${object.consignorCode})`;
      temp.value = object.consignorCode;
      temp.raw = { ...object };
      return (consignorNames[index] = temp);
    });
  }

  let handleChange = (value, data) => {
    let filteredoptions = consignor.filter(
      (item) => item.consignorCode == data.value
    );
    setFieldValue(name, data.value);
    if (props?.consignorRaw) {
      setFieldValue(props.consignorRaw, filteredoptions[0]);
    }

    if (props?.consignorRaw && props?.consignor_placeholder) {
      let selected = data.options.filter((object, index) => {
        if (object.value == data.value) {
          return object.text
        }
      });
      setFieldValue(props.consignorRaw, selected?.[0]);
      setFieldValue(props.consignor_placeholder, selected?.[0]?.text);
    }
  }

  const setAddedConsignorFetch = () => {
    setAddedConsignor(!addedConsignor)
  }

  let OptionsList = consignorNames.sort((a, b) => a.text.toLowerCase() > b.text.toLowerCase() ? 1 : -1);
  return (
    <div className="display-flex-center width-100cent">
      <div className="consignor_dropdown">
        <Dropdown
          selection
          search
          clearable
          loading={isloading ? true : false}
          style={{ width: "100%" }}
          onChange={handleChange}
          placeholder={props.placeholder}
          // search
          // onChange={(value, data) => setFieldValue(name, data.value)}
          options={OptionsList}
          onSearchChange={handleSearch}
          noResultsMessage="Search for Result"
          {...props}
        />
      </div>
      <div className="create-modal-master">
        <ModalCreateConsignor
          reFetchConsignee={setAddedConsignorFetch}
        />
      </div>
    </div>
  );
};

export default ConsignorWithCreate;
